import PropTypes from 'prop-types';
import React from 'react';
import withKeyLayer from 'react-key-layers';
import {
  DONE,
  INBOX_EDIT_MESSAGE_TITLE,
} from '../../../../../../constants/texts';
import * as types from '../../../types';
import onlyWhenDefined from '../../onlyWhenDefined';
import { isEmptyEditorContent, isMetaKeyPressed, flow } from '../../../utils';
import EditZone from './EditZone';
import {
  TitleContainer,
  CreateIcon,
  EditZoneContainer,
} from './EditMessageModal.styled';
import { EDIT_CONVERSATION_MODAL_LAYER } from '../../../modalLayersConfig';
import { ENTER } from '../../../../../../utils/keyCodes';

import Dialog, {
  DialogTitle,
  DialogContent,
  DialogActions,
} from '../../../../common/Dialog';

class EditMessageModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      emptyContent: false,
      waitingForEditor: false,
    };

    this.editZone = null;

    this.onChange = this.onChange.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.setEditZone = this.setEditZone.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.focusEditZone = this.focusEditZone.bind(this);
  }

  componentDidMount() {
    const { addKeyListener } = this.props;
    addKeyListener('keyDown', this.onKeyDown);
  }

  onKeyDown(e) {
    if (isMetaKeyPressed(e) || e.keyCode === ENTER) return;
    this.focusEditZone();
  }

  onChange(content) {
    this.setState({ emptyContent: isEmptyEditorContent(content) });
  }

  async onConfirm() {
    if (!this.editZone) return;

    this.setState({ waitingForEditor: true });

    // Wait for any pending action (e.g. file upload) in the editor before saving
    this.editZone.editor.editor.whenEditorReady(async () => {
      const { close, save } = this.props;
      this.setState({ waitingForEditor: false });
      await save(JSON.stringify(this.editZone.export()));
      close();
    });
  }

  setEditZone(reference) {
    this.editZone = reference;
  }

  focusEditZone() {
    if (!this.editZone) return;
    this.editZone.editor.focus();
  }

  render() {
    const { close, message, saving } = this.props;

    const { emptyContent, waitingForEditor } = this.state;

    return (
      <Dialog
        id="edit-message-modal"
        open
        onClose={close}
        maxWidth="md"
        style={{ zIndex: 1600 }}
      >
        <DialogTitle id="edit-message-modal-dialogtitle" onClose={close}>
          <TitleContainer>
            <CreateIcon />
            {INBOX_EDIT_MESSAGE_TITLE}
          </TitleContainer>
        </DialogTitle>
        <DialogContent>
          <EditZoneContainer>
            <EditZone
              ref={this.setEditZone}
              initialContent={message.content}
              onChange={this.onChange}
            />
          </EditZoneContainer>
        </DialogContent>
        <DialogActions
          primary={{
            label: DONE,
            loading: saving,
            disabled: emptyContent || saving || waitingForEditor,
            onClick: this.onConfirm,
          }}
          secondary={{
            label: 'Cancel',
            onClick: close,
          }}
        />
      </Dialog>
    );
  }
}

EditMessageModal.propTypes = {
  close: PropTypes.func.isRequired,
  message: types.Message,
  save: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  addKeyListener: PropTypes.func.isRequired,
};

EditMessageModal.defaultProps = {
  message: undefined,
  saving: false,
};

const wrap = flow(
  withKeyLayer(EDIT_CONVERSATION_MODAL_LAYER),
  onlyWhenDefined(['message'])
);

export default wrap(EditMessageModal);
